var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
let Pager = class Pager extends Vue {
    constructor() {
        super(...arguments);
        this.firstPage = null;
        this.pageList = [];
        this.lastPage = null;
        this.activePage = 1;
    }
    created() {
        this.init();
    }
    init() {
        this.pageList = [];
        this.firstPage = null;
        this.lastPage = null;
        if (this.numberOfPage < 6) {
            for (let i = 0; i < this.numberOfPage; i++) {
                this.pageList.push({ value: i + 1 });
            }
        }
        else {
            this.rearange();
        }
        this.activePage = this.currentPage;
    }
    rearange() {
        this.pageList = [];
        this.firstPage = null;
        this.lastPage = null;
        if (this.activePage < 3) {
            let max = this.numberOfPage < 6 ? this.numberOfPage : 5;
            for (let i = 0; i < max; i++) {
                this.pageList.push({ value: i + 1 });
            }
            this.lastPage = this.numberOfPage < 6 ? null : { value: this.numberOfPage };
        }
        else {
            let start = this.activePage - 2;
            let end = this.activePage + 2 > this.numberOfPage ? this.numberOfPage : this.activePage + 2;
            for (let i = start; i < end + 1; i++) {
                this.pageList.push({ value: i });
            }
            if (start > 1) {
                this.firstPage = { value: 1 };
            }
            if (end < this.numberOfPage) {
                this.lastPage = { value: this.numberOfPage };
            }
        }
    }
    goNext() {
        if (this.activePage + 1 > this.numberOfPage)
            return;
        this.activePage++;
        this.rearange();
        this.onPageChange();
    }
    goPrev() {
        if (this.activePage - 1 == 0)
            return;
        this.activePage--;
        this.rearange();
        this.onPageChange();
    }
    onPageClick(value) {
        this.activePage = value;
        if (this.numberOfPage > 5) {
            this.rearange();
        }
        this.onPageChange();
    }
    onNumberOfPage() {
        this.init();
    }
    onPageChange() {
        history.pushState({}, "", "?page=" + this.activePage);
        return this.activePage;
    }
};
__decorate([
    Prop({ type: Object })
], Pager.prototype, "labels", void 0);
__decorate([
    Prop()
], Pager.prototype, "numberOfPage", void 0);
__decorate([
    Prop()
], Pager.prototype, "currentPage", void 0);
__decorate([
    Watch('numberOfPage')
], Pager.prototype, "onNumberOfPage", null);
__decorate([
    Emit('change-page')
], Pager.prototype, "onPageChange", null);
Pager = __decorate([
    Component
], Pager);
export default Pager;
